module.exports = __webpack_public_path__ + "img/gift.743c6699.jpg";